/**
 * Platform-admin–specific class bundles.
 * Generic table / modal classes live in @shared/lib — import from there.
 * This file only holds tokens unique to the platform admin SPA.
 */

/* ── Alerts ── */
export const alertError =
  'rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800 dark:border-red-900 dark:bg-red-950/40 dark:text-red-200';
export const alertSuccess =
  'rounded-xl border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-800 dark:border-green-900 dark:bg-green-950/40 dark:text-green-200';
export const alertWarning =
  'rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-200';
export const alertInfo =
  'rounded-xl border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-800 dark:border-blue-900 dark:bg-blue-950/40 dark:text-blue-200';

/* ── Card ── */
export const cardClass =
  'rounded-xl border border-border-subtle bg-white p-6 shadow-card dark:border-border-subtle-dark dark:bg-surface-dark dark:shadow-card-dark';

/* ── Tabs (underline style) ── */
export const tabBtnActive =
  '-mb-px border-b-2 border-primary text-primary';
export const tabBtnInactive =
  '-mb-px border-b-2 border-transparent text-slate-500 dark:text-slate-400 hover:text-primary dark:hover:text-white';

/* ── Links ── */
export const linkAccentClass = 'font-medium text-primary hover:underline dark:text-primary-light';

